"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var config_provider_1 = require("../config-provider");
var context_1 = tslib_1.__importDefault(require("./context"));
var radio_1 = tslib_1.__importDefault(require("./radio"));
var RadioButton = function (props, ref) {
    var radioGroupContext = React.useContext(context_1.default);
    var getPrefixCls = React.useContext(config_provider_1.ConfigContext).getPrefixCls;
    var customizePrefixCls = props.prefixCls, radioProps = tslib_1.__rest(props, ["prefixCls"]);
    var prefixCls = getPrefixCls('radio-button', customizePrefixCls);
    if (radioGroupContext) {
        radioProps.checked = props.value === radioGroupContext.value;
        radioProps.disabled = props.disabled || radioGroupContext.disabled;
    }
    return React.createElement(radio_1.default, tslib_1.__assign({ prefixCls: prefixCls }, radioProps, { type: "radio", ref: ref }));
};
exports.default = React.forwardRef(RadioButton);
//# sourceMappingURL=radioButton.js.map